// extracted by mini-css-extract-plugin
export var avatarContainer = "_5l-0";
export var avatarTypingWave = "_5l-i";
export var gray = "_5l-f";
export var green = "_5l-c";
export var icon = "_5l-9";
export var image = "_5l-1";
export var lg = "_5l-6";
export var md = "_5l-5";
export var presenceDot = "_5l-b";
export var red = "_5l-d";
export var sm = "_5l-4";
export var status = "_5l-a";
export var typingDot = "_5l-h";
export var typingPill = "_5l-g";
export var xl = "_5l-7";
export var xs = "_5l-3";
export var xxl = "_5l-8";
export var xxs = "_5l-2";
export var yellow = "_5l-e";